import React from 'react';
import { StagingPanel } from '../components/layout/MainPanels/StagingPanel/StagingPanel';

export const StagingScreen = () => {
    return <StagingPanel />;
};
